import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChange,
} from '@angular/core';
import { HistoryOutput } from '../../../models/history.model';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
  standalone: false,
})
export class HistoryComponent {
  @Output() update = new EventEmitter();
  @Input() historyItems: any[] = [];
  @Input() isViewHistory: boolean = false;

  history: HistoryOutput = new HistoryOutput();

  constructor() {}

  ngOnInit(): void {}

  save() {
    this.update.emit(this.history);
  }

  ngOnChanges(changes: { [property: string]: SimpleChange }) {
  }
}
